<template>
  <div class="bg-login">
    <img class="login-img" src="../assets/images/logo.png" alt />
    <div class="login-container">
      <div class="text-center">
        <h6 class="login-welcome">Bem-vindo ao Portal do Cliente</h6>
      </div>
      <div class="forgot-password" v-show="forgot_password">
        <p class="text-center">
          Insira o seu email para iniciar o processo de alteração de senha
        </p>
        <label class="login-label">E-mail</label>
        <br />
        <input class="login-input" type="text" v-model="email" />
        <br />
      </div>
      <div class="login-form" v-show="!forgot_password">
        <label class="login-label">E-mail</label>
        <br />
        <input class="login-input" data-testid="login-email" v-on:keyup.enter="login" type="text" v-model="email" />
        <br />
        <label class="login-label mt-3">Senha</label>
        <br />
        <div v-if="isEdge">
          <!-- Campo de entrada para Edge -->
          <input class="login-input" data-testid="login-password" v-on:keyup.enter="login" type="password" v-model="password" />
          <br />
        </div>
        <div v-else class="password-container">
          <!-- Campo de entrada com botão para alternar visibilidade -->
          <input :type="showPassword ? 'text' : 'password'" class="login-input" data-testid="login-password" v-on:keyup.enter="login"
            v-model="password" />
          <button style="margin-right: 20px; margin-top: 10px" type="button" class="toggle-password"
            @click="togglePasswordVisibility">
            <font-awesome-icon :icon="['fas', showPassword ? 'eye-slash' : 'eye']" />
          </button>
        </div>


      </div>

      <button class="login-btn" data-testid="login-submit" @click="login" v-show="!forgot_password">
        Acessar o Portal
      </button>
      <button class="login-btn" @click="forgot" v-show="forgot_password">
        Enviar
      </button>
      <hr>
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <div class="login-forgot-password clickable" @click="forgot_password = !forgot_password">
              {{ forgot_password_text }}
            </div>
          </div>
        </div>

        <div class="col-md-12 mt-3">
          <div class="text-center">
            <router-link v-show="!forgot_password" class="login-forgot-password clickable" to="/register">
              Ainda não tem cadastro? Solicite seu acesso!
            </router-link>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      email: "",
      password: "",
      showPassword: false, // Controle de visibilidade da senha
      forgot_password: false,
      isEdge: false, // Define se o navegador é Edge

    };
  },
  computed: {
    forgot_password_text() {
      return this.forgot_password ? "Fazer login" : "Esqueci minha senha";
    },
  },
  mounted() {
    this.showPassword = false;
    this.detectEdge(); // Detecta o navegador ao carregar o componente
  },
  methods: {
    detectEdge() {
      const userAgent = navigator.userAgent || navigator.userAgentData;
      this.isEdge = /Edg\//.test(userAgent); // Verifica se o navegador é Edge
    },
    togglePasswordVisibility() {
      if (this.password.length === 0) {
        this.showPassword = false;
      } else {
        this.showPassword = !this.showPassword;
      }
    },
    login() {
      const self = this;
      const api = this.$store.state.api + "login";

      axios
        .post(api, {
          email: self.email,
          password: self.password,
        })
        .then((response) => {
          self.$store.dispatch("setToken", response.data);
        })
        .catch((error) => {
          // if (error.response.status == 403) this.$route.push({name: 'terms-of_use'})
          this.$toast.error("Credenciais Inválidas");
        });
    },
    forgot() {
      const self = this;
      const api = this.$store.state.api + "user/recovery";

      axios
        .post(api, {
          email: self.email,
        })
        .then((response) => {
          this.$toast.success(
            "Sucesso, enviamos um email para " +
            self.email +
            ". Por favor, confira a sua caixa de entrada! "
          );
        })
        .catch((error) => {
          this.$toast.error("Falha ao enviar email para " + self.email + ".");
        });
    },
  },
};
</script>
<style scoped>
.password-container {
  position: relative;
  display: flex;
  align-items: center;
}

.toggle-password {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
}

.toggle-password:focus {
  outline: none;
}

.login-input {
  width: 100%;
  padding-right: 2.5rem;
  /* Adiciona espaço para o botão */
}

body {
  height: 100vh !important;
}

.bg-login {
  background: rgba(0, 0, 0, 0) url("../assets/images/bg-login.jpg") no-repeat scroll;
  background-repeat: no-repeat;
  background-color: #fff;
  background-size: 100%;
  height: 100vh;
  overflow-y: hidden;
  background-position: 30% 45%;
}

@media (max-width: 425px) {
  
  .bg-login {
    background: none;
  }

  .login-container {
    display: block;
    margin: 25px auto;
    width: 90%;
    /* height: 100%; */
    background-color: #fff;
  }
}


@media (max-width: 1024px) and (min-width: 768px) {
  .bg-login {
    background: none;
    background: rgba(0, 0, 0, 0) url("../assets/images/bg-login.jpg") no-repeat scroll;
    background-repeat: no-repeat;
    background-color: #fff;
    background-size: 100%;
  }

  .login-container {
    display: block;
    margin: 25px auto;
    width: 50%;
    /* height: 80%; */
    background-color: #fff;
  }
}
</style>
